import { httpServices } from '@libs/data-access/queries'
import type {
  PayPeriodPathParams,
  PayPeriodSchema,
  QueryFnParams,
  PayPeriodQueryParams,
  PayPeriodPostPayload,
  PayPeriodPutPayload,
  PayPeriodsResponse
} from '@libs/data-access/queries'

/**
 * Fetch all pay period
 */
export type FetchPayPeriodsOptions = {
  queryParams?: PayPeriodQueryParams
}

export const fetchPayPeriods = async (opts?: FetchPayPeriodsOptions) => {
  const response = await httpServices.core.get<PayPeriodsResponse>(
    `/accounts/${httpServices.authInfo.accountId}/pay_periods`,
    {
      params: opts?.queryParams
    }
  )
  return response.data
}

/**
 * Fetch one pay period
 */
export type FetchPayPeriodOptions = QueryFnParams<{
  pathParams: PayPeriodPathParams
  queryParams: { include?: 'reports' }
}>

export const fetchPayPeriod = async (opts: FetchPayPeriodOptions) => {
  const response = await httpServices.core.get<PayPeriodSchema>(
    `/pay_periods/${opts.pathParams.pay_period_id}`,
    {
      params: opts.queryParams
    }
  )

  return response.data
}

/**
 * Create a pay period
 */
export type CreatePayPeriodOptions = QueryFnParams<{
  payload: PayPeriodPostPayload
}>

export const createPayPeriod = async (opts?: CreatePayPeriodOptions) => {
  const response = await httpServices.core.post<PayPeriodSchema>(
    `/pay_periods`,
    opts?.payload
  )
  return response.data
}

/**
 * Bulk update pay periods
 */
export type BulkUpdatePayPeriodOptions = QueryFnParams<{
  payload: PayPeriodPutPayload
}>

export const bulkUpdatePayPeriod = async (
  opts?: BulkUpdatePayPeriodOptions
) => {
  const response = await httpServices.core.put<PayPeriodSchema[]>(
    `/pay_periods/bulk_update`,
    opts?.payload
  )
  return response.data
}

/**
 * Delete a pay period
 */
export type DeletePayPeriodOptions = QueryFnParams<{
  pathParams: PayPeriodPathParams
}>

export const deletePayPeriod = async (opts: DeletePayPeriodOptions) => {
  const response = await httpServices.core.delete(
    `/pay_periods/${opts.pathParams.pay_period_id}`
  )
  return response.data
}

/**
 * Synchronize pay period in ComboPay
 */
export type SyncronizePayPeriodToComboPayOptions = QueryFnParams<{
  pathParams: PayPeriodPathParams
}>
export const synchronizePayPeriodToCompoPay = async (
  opts: SyncronizePayPeriodToComboPayOptions
) => {
  const response = await httpServices.core.get(
    `/pay_periods/${opts.pathParams.pay_period_id}/synchronize_to_combo_pay`
  )
  return response.data
}

/**
 * Submit pay period in ComboPay
 */
export type SubmitPayPeriodToComboPayOptions = QueryFnParams<{
  pathParams: PayPeriodPathParams
  payload: { start_payroll_workflow?: boolean }
}>
export const submitPayPeriodToCompoPay = async (
  opts: SubmitPayPeriodToComboPayOptions
) => {
  const response = await httpServices.core.post(
    `/payroll/pay_periods/${opts.pathParams.pay_period_id}/submit`,
    opts?.payload
  )
  return response.data
}
